import Api from '../../shared/services/api'

const baseUrl = "Distributors";
export default {

  get() {
    return Api().get(baseUrl);
  },
  typeHead(searchTerm, all) {
    return Api().get(`${baseUrl}/typeHead?${searchTerm}&all=${all}`);
  },
  query(options) {
    const qParams = new URLSearchParams(options);
    return Api().get(`${baseUrl}?${qParams.toString()}`);
  },
  edit(entity) {
    if (entity.id) return Api().put(`${baseUrl}/${entity.id}`, entity);
    return this.add(entity);
  },
  add(entity) {
    return Api().post(baseUrl, entity);
  },
  delete(id) {
    return Api().delete(`${baseUrl}/${id}`);
  }
}